import { useTranslation } from 'react-i18next';

import { OppvarmingFormData } from '../../../types';

export const useVedValidation = () => {
  const { t } = useTranslation();

  const validateVedSelection = (_: boolean, formValues: OppvarmingFormData) => {
    if (
      !formValues.ved?.value?.apenPeis?.selected &&
      !formValues.ved?.value?.peisMedDor?.selected &&
      !formValues.ved?.value?.lukketOvn?.selected
    ) {
      return t('form.oppvarming.ved.error');
    }
    return true;
  };

  return { validateVedSelection };
};
